import { render, staticRenderFns } from "./imgJ.vue?vue&type=template&id=36c64111"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c64111')) {
      api.createRecord('36c64111', component.options)
    } else {
      api.reload('36c64111', component.options)
    }
    module.hot.accept("./imgJ.vue?vue&type=template&id=36c64111", function () {
      api.rerender('36c64111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgJ.vue"
export default component.exports